export default __webpack_public_path__ + "static/media/vehicle-crash-los.97ddaf67.png";